module.exports = __webpack_public_path__ + "static/media/kayak_active_ic.8f9d97e9.svg";